export const identity = (x) => x;
//# sourceMappingURL=identity.js.map